import { AxiosError } from 'axios';
import {
  CustomCallbackErrorAxiosInstance,
  ErrorBackendCore,
  AxiosResponseExtended,
  AxiosErrorExtended,
  ErrorRequestHasBeenMade,
  ErrorRequestNetworkError,
} from '@/types';
import store from '@/store';
import { storeHTPPErrorInfoEvent } from '@/store/commonDuck/NotificationDuck';
import { bugsnagNotify } from '@/plugins';

interface ErrorObjectHTTPRequest {
  requestMade: (
    error: AxiosErrorExtended<ErrorBackendCore>
  ) => ErrorRequestHasBeenMade;
  networkError: (error: AxiosError) => ErrorRequestNetworkError;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reportBugsnag = (error: any) => {
  if (process.env.REACT_APP_NODE_ENV === 'PRODUCTION') {
    bugsnagNotify(error);
  }
};

const errorObjectHTTPRequest: ErrorObjectHTTPRequest = {
  requestMade: error => {
    const {
      config: originalRequest,
      response: { data, status } = {} as AxiosResponseExtended<
        ErrorBackendCore
      >,
    } = error;
    return {
      originalRequest,
      data,
      status,
    };
  },
  networkError: error => {
    const { stack, message } = error;
    return {
      stack,
      message,
      networkError: true,
    };
  },
};

// const sendBackOriginalRequest = async (
//   originalRequest,
//   useCustomCallBackError,
// ) => {
//   try {
//     const result = await axios(originalRequest);
//     return Promise.resolve(result);
//   } catch (error) {
//     if (error.response) {
//       const errorObject = errorObjectHTTPRequest.requestMade(error);
//       if (
//         errorObject.status ===
//         constants.errorCode.HTTP_ERROR_CODE.HTTP_ERROR_CODE_500
//       ) {
//         toaster.showMessageToaster({
//           message: constants.errorMessage.INTERNAL_SERVER_ERROR,
//           type: 'danger',
//         });
//       }
//       return Promise.reject(errorObject);
//     }
//     if (useCustomCallBackError[constants.errorCode.NETWORK_ERROR]) {
//       useCustomCallBackError[constants.errorCode.NETWORK_ERROR]();
//       return Promise.reject(errorObjectHTTPRequest.networkError(error));
//     }
//     toaster.showMessageToaster({
//       message: constants.errorMessage.NETWORK_ERROR,
//       type: 'danger',
//     });
//     return Promise.reject(errorObjectHTTPRequest.networkError(error));
//   }
// };

// const errorHandlingDefaultUnauthorize = async (
//   errorObject,
//   useCustomCallBackError,
// ) => {
// try {
//   const refreshTokenFromStorage = await common.getAsyncStorage(
//     'refreshToken',
//   );
//   const result = await RefreshTokenApi({
//     refresh_token: refreshTokenFromStorage,
//   });
//   const {
//     data: {token, refresh_token: refreshToken},
//   } = result;
//   common.storeObjectInAsyncStorage({token, refreshToken});
//   store.dispatch(storeAuthToken({token, refreshToken}));
//   const originalRequestModifiedHeader = {
//     ...errorObject.originalRequest,
//     headers: {
//       ...errorObject.originalRequest.headers,
//       Authorization: `Bearer ${token}`,
//     },
//   };
//   return sendBackOriginalRequest(
//     originalRequestModifiedHeader,
//     useCustomCallBackError,
//   );
// } catch (error) {
//   await common.logout();
// }
// return Promise.reject(errorObject);
// };

const interceptErrorHTTP: (
  error: AxiosError,
  useCustomCallBackError?: CustomCallbackErrorAxiosInstance
) => Promise<ErrorRequestHasBeenMade | ErrorRequestNetworkError> = (
  error,
  useCustomCallBackError = {} as CustomCallbackErrorAxiosInstance
) => {
  if (error.response) {
    const errorObject = errorObjectHTTPRequest.requestMade(
      error as AxiosErrorExtended<ErrorBackendCore>
    );
    if (errorObject.status >= 500) {
      reportBugsnag(JSON.stringify(errorObject));
      store.dispatch(
        storeHTPPErrorInfoEvent({
          isOpen: true,
          type: 'INTERNAL_SERVER_ERROR',
        })
      );
    }
    return Promise.reject(errorObject);
  }
  const unknownErrorObject = errorObjectHTTPRequest.networkError(error);
  if (useCustomCallBackError.UNKNOWN_ERROR) {
    useCustomCallBackError.UNKNOWN_ERROR();
  } else {
    store.dispatch(
      storeHTPPErrorInfoEvent({
        isOpen: true,
        type: 'NETWORK_ERROR',
      })
    );
  }
  return Promise.reject(unknownErrorObject);
};

// /**
//  * process error handling global
//  * @param {Object} error please specify message as error.message, otherwise it wont log message to crashlytics
//  * @param {Function} callback function
//  */
const errorHandlingGlobal: (
  error: ErrorRequestHasBeenMade | ErrorRequestNetworkError | Error,
  callback?: CustomCallbackErrorAxiosInstance
) => void = (error, callback = {}) => {
  // // log here when development only
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('error catched', error);
  }
  const defaultExecFunct = () => null;
  const errorRequestHasBeenMade = error as ErrorRequestHasBeenMade;
  const errorRequestNetworkError = error as ErrorRequestNetworkError;
  if (errorRequestHasBeenMade.status) {
    const callbackExecHTTPStatusError =
      callback[errorRequestHasBeenMade.status] || defaultExecFunct;
    callbackExecHTTPStatusError(errorRequestHasBeenMade);
  } else if (errorRequestNetworkError.networkError) {
    const callbackExecNetworkError = callback.NETWORK_ERROR || defaultExecFunct;
    callbackExecNetworkError(errorRequestNetworkError);
  } else {
    const callbackExecUnknownError = callback.UNKNOWN_ERROR || defaultExecFunct;
    callbackExecUnknownError(error);
    reportBugsnag(error);
  }
};

export {
  //   errorObjectHTTPRequest,
  //   errorHandlingDefaultUnauthorize,
  reportBugsnag,
  interceptErrorHTTP,
  errorHandlingGlobal,
};
